<template>
    <div class="config-step">
        <p @click="toggle()" :class="{'is-open': isOpen}">
            {{ step.title }}
            <svg class="arrow" width="14px" height="9px" viewBox="0 0 14 9">
                <polygon fill="#A7A7A7" fill-rule="nonzero" transform="translate(7.000000, 4.646447) rotate(-180.000000) translate(-7.000000, -4.646447) " points="12.2928932 8.70710678 13.7071068 7.29289322 7 0.585786438 0.292893219 7.29289322 1.70710678 8.70710678 7 3.41421356"></polygon>
            </svg>
        </p>
        <ul>
            <li v-for="(item, index) in step.steps" :key="index">
                <span v-html="item.content"></span>
                <ul v-if="item.subSteps">
                    <li v-for="(sub, sIndex) in item.subSteps" :key="`sub-${sIndex}`" v-html="sub"></li>
                </ul>
            </li>
        </ul>
    </div><!-- end.config-step -->
</template>
<script>
    export default {
        props: ['step'],
        data() {
            return {
                isOpen: false
            }
        },
        methods: {
            toggle() {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>